import React, { useState } from 'react';

function Step4({answers, setAnswers}) {
    
    const answerList = [
        "부유방",
        "짝가슴",
        "새가슴",
        "등살",
        "가슴을 안정적으로 덮길 원해요",
        "해당사항 없음"
    ];

    const handleClick = (selectedAnswer) => {
        // "해당사항 없음"을 선택한 경우의 특별 처리
        if (selectedAnswer === "해당사항 없음") {
            if (!answers.includes("해당사항 없음")) {
                setAnswers(["해당사항 없음"]); // 다른 모든 선택 해제
            } else {
                setAnswers([]); // 해당사항 없음 선택 해제
            }
            return;
        }

        // "해당사항 없음"이 이미 선택되어 있는 경우, 그것을 제거
        if (answers.includes("해당사항 없음")) {
            setAnswers([selectedAnswer]);
            return;
        }

        // 일반적인 다중 선택 처리
        if (answers.includes(selectedAnswer)) {
            setAnswers(answers.filter(item => item !== selectedAnswer));
        } else {
            setAnswers([...answers, selectedAnswer]);
        }
    };

    return (
        <>
            {answerList?.map((data, idx) => (
                <div 
                    key={idx}
                    className={answers.includes(data) ? "answer-btn active" : "answer-btn"}
                    onClick={() => handleClick(data)}
                >
                    {data}
                </div>
            ))}
        </>
    );
}

export default Step4;